<template>
  <div class="purchase">
    <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
      <div class="complementary hidden-sm-and-up">
        <el-collapse accordion v-model="accordionOpen">
          <el-collapse-item name="accordion">
            <template slot="title">
              <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg" class="order-summary-toggle__icon">
                <path
                  d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"></path>
              </svg>
              <span v-if="this.accordionOpen === 'accordion'"><span>{{ $t('hideOrderSummary') }}</span></span>
              <span v-else>{{ $t('showOrderSummary') }}</span>
              <span class="order-summary-toggle__total-recap total-recap">
                <span class="total-recap__final-price">${{this.GrandTotal}}</span>
              </span>
            </template>
            <div class="sidebar hidden-sm-and-up">
              <div class="sidebar__header"></div>
              <div class="sidebar__content">
                <div class="order-summary order-summary--is-collapsed">
                  <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                  <div class="order-summary__sections">
                    <div class="order-summary__section order-summary__section--total-lines">
                      <table class="total-line-table">
                        <tbody class="total-line-table__tbody">
                          <tr class="total-line total-line--subtotal">
                            <th class="total-line__name">
                              {{ $t('SONum') }}
                            </th>
                            <td class="total-line__price">
                              <span class="order-summary__emphasis">
                                {{orderDetail.SONum}}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot class="total-line-table__footer">
                          <tr class="total-line">
                            <th class="total-line__name total_name payment-due-label">
                              <span class="payment-due-label__total">
                                {{ $t('total') }}
                              </span>
                            </th>
                            <td class="total-line__price usd_price payment-due">
                              <span class="payment-due__currency">USD</span>
                              <span class="payment-due__price">${{orderDetail.TotalPrice}}</span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wrap">
        <div class="main">
          <main class="main__content">
            <div class="step__sections">
              <div class="section section--shipping-address ">
                <div class="addPayment">
                  <div class="section__header">
                    <h2 class="section__title"></h2>
                  </div>
                  <!-- <header class="main__header hidden-sm-and-down"> -->
                  <h2 class="section__title">{{ $t('choosePaymentMethod') }}</h2>
                  <div class="payment-container" v-bind:style="{marginBottom: 10 + 'px'}">
                    <div @click="showPaymentError=true">
                      <el-radio className="radio-purchase" v-model="paymentMethod" v-bind:label="$t('alipay')"><span><i class="fab fa-alipay fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" v-model="paymentMethod" v-bind:label="$t('wechatpay')"><span><i class="fab fa-weixin fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" disabled="true" v-model="paymentMethod" v-bind:label="$t('creditcard')"><span><i class="far fa-credit-card fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" disabled="true" v-model="paymentMethod" v-bind:label="$t('check')"><span><i class="fas fa-money-check-alt fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" disabled="true" v-model="paymentMethod" v-bind:label="$t('ACH')"><span style="fontSize: 30px;">ACH</span></el-radio>
                    </div>
                  </div>
                  <!-- </header> -->
                  <div v-if="paymentMethod === 'creditcard' && !this.cardLoading && !this.cardSuccess" class="section__content">
                    <div class="title" :class="isAddPayment?'':'bg_none'" @click="isAddPayment = !isAddPayment">
                      <i :class="isAddPayment?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addPayment') }}</span>
                    </div>
                    <div class="fieldset" v-show="isAddPayment">
                      <div class="field">
                        <!--card info-->
                        <div>
                          <el-form-item v-bind:label="$t('cardHolderName')" prop="card_holder_name">
                            <el-input
                              v-bind:placeholder="$t('cardHolderName')"
                              v-model="sizeForm.card_holder_name"
                              @keyup.native="contact">
                            </el-input>
                          </el-form-item>
                          </div>
                          <div>
                            <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                              <el-input
                                v-bind:placeholder="$t('creditCardNumber')"
                                v-model="sizeForm.Card"
                                @keyup.native="contact"
                                @input="cardNumberFormatter(sizeForm.Card)"
                              ></el-input>       
                            </el-form-item>
                          </div>
                          <div class="two">
                            <div class="width">
                              <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                                <el-input
                                  v-bind:placeholder="$t('cardExpiration')"
                                  v-model="sizeForm.Expiration"
                                  @keyup.native="contact"
                                  @input="cardExpireDateFormatter(sizeForm.Expiration)"
                                  :maxlength="5"
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="width">
                              <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                                <el-input v-bind:placeholder="$t('cvc')" v-model="sizeForm.CVC" :maxlength="4"
                                          @keyup.native="contact"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <!--单选开始-->
                          <!-- 
                          <div class="checkbox-wrapper">
                            <el-checkbox v-model="sizeForm.storage">Save Your info for later use</el-checkbox>
                          </div> 
                          -->
                          <span v-show="cardError" style="color:red">{{cardError}}</span>
                          <el-button @click="fetchCardToken()" class="place btn " >{{ $t('submitCardInfo') }}</el-button>
                          <!--end单选结束-->
                          <!--end card infos-->
                        </div>
                      </div>
                    </div>
                    <div v-else-if="this.cardLoading" class="svg">
                      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="#ff6f37" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                          <animateTransform attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="1s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    </div>
                    <div v-else-if="!this.cardLoading && this.cardSuccess"><h3>{{ $t('cardSubmitSuccess') }}</h3></div>
                  </div>
                  <span v-show="cardError" style="color:red">{{cardError}}</span>
                </div>
              </div>
          </main>
          <!-- <footer class="main__footer" v-if="this.necessaryCartItems.AvailableCredit !== 0">
            <h2 class="section__title hidden-sm-and-down">{{ $t('userCredit') }}</h2>
              <div style="marginTop: 20px; marginBottom: 20px">
                <el-checkbox v-model="IsCreditUsed"></el-checkbox>
                <span style="marginLeft: 10px; fontSize: 17px">{{ $t('use_my_credit_balance') }} <span style="color: red">(${{this.necessaryCartItems.AvailableCredit}})</span></span>
              </div>
          </footer> -->
        </div>
        <div class="sidebar hidden-sm-and-down">
          <div class="sidebar__header"></div>
            <div class="sidebar__content">
              <div class="order-summary order-summary--is-collapsed">
                <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                <div class="order-summary__sections">
                  <div class="order-summary__section order-summary__section--total-lines"  :class="(scrollPosition < '-110') ? 'fixPosition':'' " >
                    <table class="total-line-table">
                      <tbody class="total-line-table__tbody">
                      <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('SONum') }}
                        </th>
                        <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            {{orderDetail.SONum}}
                          </span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="total-line-table__footer">
                      <tr class="total-line">
                      <th class="total-line__name total_name payment-due-label">
                        <span class="payment-due-label__total">
                          {{ $t('total') }}
                        </span>
                      </th>
                      <td class="total-line__price usd_price payment-due">
                        <span class="payment-due__currency">
                          USD
                        </span>
                        <span class="payment-due__price">${{orderDetail.TotalPrice}}</span>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                  <el-button
                    :disabled="!isFormValidForSubmission()"
                    @click="onSubmit"
                    class="place btn"
                    style="marginTop: 50px;"
                  >
                    {{ $t('placeOrder') }}
                  </el-button>
                  <div v-if="this.orderFailed">
                    <span class="error-message">
                      Error: {{this.orderFailMessage}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { validateUSZipCode, validatePhoneNumber } from "../../config/validation";
import moment from "moment";

export default {
  name: "payment",
  data() {
    return {
      scrollPosition: null,
      accordionOpen: 'accordion',
      labelPosition: 'top',
      promoCode: '',
      card_holder_name: '',
      order: false,
      radio: '', // 单选框默认
      deliveryTime: '',
      creditCardSuccess: false,
      formLabelAlign: {
        name: '',
        password: '',
      },
      showPaymentError: false,
      paymentMethod: '',
      activeNames: ['1'],
      Subtotal:15,
      total:15,
      // 表单默认数据
      sizeForm: {
        name: "",
        subscribe: true,//是否订阅
        firstName: '',//名字
        lastName: '',//名字
        address: '',//地址
        apartment: '',//地址
        city: '',//城市
        code: '',//编码
        phone: '',//联系方式
        Country: 'United States', //国家/地区
        State: 'CA',//地区
        gateCode: '',//送货上门详细地址
        whether: 1,//是否确认
        confirmAddress: '',//确认地址
        Card: '',//卡号
        Expiration: '',//到期时间
        CVC: '',//安全码
        storage: true,//是否保存信息
        card_holder_name: '',
      },
      cardData: {
        cardNumber: null,
        expiry: null,
        cvc: null,
        // cardType: null,
        CardName: null,
        salesOrderId: null,
      },
      rules:{
        Card:[
          { required: true, message: 'Card Info is Required', trigger: 'blur' },
          { min: 16, max: 23, message: 'Card number should be 13 - 19 digits', trigger: 'blur' },
        ],
        Expiration:[
          { required: true, message: 'Expiration Date is Required', trigger: 'blur' },
          { min: 5, max: 5, message: 'Expiration data shoud be in format MM/YY', trigger: 'blur' }
        ],
        CVC:[
          { required: true, message: 'Security Code is Required', trigger: 'blur' },
          { min: 3, max: 4, message: 'CVC length at least 3', trigger: 'blur' }
        ],
      },
      // input label
      input_label: false,
      firstName: false,
      lastName: false,
      apartment: false,
      city: false,
      code: false,
      phone: false,
      privacy: false,
      refund: false,
      // end input label
      
      isAddPayment: false,//展示添加支付方式

      //user credit
      IsCreditUsed: false,
    }
  },
  methods: {
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard', 'updatePromoCode']),
    updateScroll() {
      this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
    },
    onSubmit(){
      let orderData = {};
      orderData.SONum = this.$store.state.warehouseOrder.orderDetail.SONum;
      orderData.PaymentType = this.paymentMethod;
      // orderData.card_reference = this.card_reference;
      
      this.$store.dispatch('warehouseOrder/submitPayment', orderData);
    },
    // check if has payment
    isFormValidForSubmission() {
      let valid = false;
      if (this.paymentMethod === 'creditcard') {
        if (this.cardSuccess) {
          valid = true;
        } else {
          valid = false
        }
      } else if (this.paymentMethod === 'wechatpay' || this.paymentMethod === 'alipay') {
        valid = true;
      } 
      if (this.orderLoading || this.cardLoading || this.windowOpening) {
        valid = false;
      }
      if (this.paymentMethod === '') {
        valid = false;
      }
      return valid;
    },
    // method for credit card
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,19}/g);
      var match = matches && matches[0] || ''
      var parts = []

      for (var i=0, len=match.length; i<len; i+=4) {
          parts.push(match.substring(i, i+4))
      }
      if (parts.length) {
          this.sizeForm.Card =  parts.join(' ')
      } else {
          this.sizeForm.Card = value
      }
    },
    cardExpireDateFormatter(date) {
      if(date.length == 3) {
        if(date[date.length - 1] !== '/') {
          var temp =  this.sizeForm.Expiration.split('');
          temp.splice(2, 0, '/');
          this.sizeForm.Expiration = temp.join('');
          return;
        }else {
          this.sizeForm.Expiration = this.sizeForm.Expiration.slice(0, 2);
        }
      }
    },
    contact(el) {
      this.sizeForm.name !== '' ? this.input_label = true : this.input_label = false;
      this.sizeForm.firstName !== '' ? this.firstName = true : this.firstName = false;
      this.sizeForm.lastName !== '' ? this.lastName = true : this.lastName = false;
      this.sizeForm.address !== '' ? this.address = true : this.address = false;
      // this.sizeForm.apartment !== '' ? this.apartment = true : this.apartment = false;
      this.sizeForm.city !== '' ? this.city = true : this.city = false;
      this.sizeForm.code !== '' ? this.code = true : this.code = false;
      this.sizeForm.phone !== '' ? this.phone = true : this.phone = false;
      // this.sizeForm.discountCode !== '' ? this.discountCode = true : this.discountCode = false
    },
    fetchCardToken() {
      let paymentData = {};
      paymentData.cardNum = this.sizeForm.Card.split(' ').join('')
      paymentData.expDate = '20' + this.sizeForm.Expiration.split("/").reverse().join("-");
      paymentData.cvv = this.sizeForm.CVC;
      paymentData.salesOrderId = this.salesOrderId;
      paymentData.card_holder_name = this.sizeForm.card_holder_name;
      // this.$store.dispatch('checkout/fetchACCardToken', paymentData)
      this.$store.dispatch('checkout/saveCreditCard', paymentData);
      this.isAddPayment = false;
    },
  },
  mounted() {
    // window.addEventListener('scroll', this.updateScroll);
  },
  beforeMount() {
    // this.$store.dispatch('cart/getCart')
    // .then(() => {
    //   const cartItems = {};
    //   cartItems.SalesOrder_id = this.$store.state.warehouseOrder.getOrderDetail.SONum;
    //   // cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
    //   cartItems.ShippingMethod = "Delivery";
    //   cartItems.TotalPrice =  this.$store.state.warehouseOrder.getOrderDetail.TotalPrice;
    // })
  },
  watch: {
    IsCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
      }
    },
    cardLoading: function(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.isAddPayment = false;
      }
    },
  },
  computed: mapState({
    orderDetail: state => state.warehouseOrder.orderDetail,
    
    salesOrderId: state => state.cart.cartProductsList.SalesOrder_id,
    card_reference: state => state.checkout.card_reference,
    customerDetails: state => state.profile.customerDetails,
    // necessaryCartItems: state => state.cart.necessaryCartItems,
    device: state => state.navbar.device,
    orderLoading: state => state.checkout.orderLoading,
    orderSuccessful: state => state.checkout.orderSuccessful,
    cardLoading: state => state.checkout.cardLoading,
    cardSuccess: state => state.checkout.cardSuccess,
    cardError: state => state.checkout.cardError,
    Savings: state => state.checkout.Savings,
    GrandTotal: state => state.checkout.GrandTotal,
    TotalPrice: state => state.checkout.TotalPrice,
    Tax: state => state.checkout.Tax,
    cartClicked: state => state.cart.cartClicked,
    itemCount: state => state.cart.itemCount,
    windowOpening: state => state.checkout.windowOpening,
    orderFailed: state => state.checkout.orderFailed,
    orderFailMessage: state => state.checkout.orderFailMessage
  }),
}
</script>

<style lang="less">
@import "../assets/css/payment.less";
@import "../assets/css/animation.less";
</style>



// WEBPACK FOOTER //
// src/view/payment.vue